
import { defineComponent, computed, useStore } from '@nuxtjs/composition-api'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  props: ['navName', 'navLocalePath', 'navHash'],
  emits: ['hide-navigation'],
  setup(props, { emit }) {
    const store = useStore()

    const country = getCountryCode()
    const shopLoginStatus = computed(() => store.getters['shoplogin/isActive'])
    const b2bShopId = computed(() => store.getters['shoplogin/getB2bShopId'])

    if (props.navName === undefined) {
      throw new Error('navName is undefined')
    }

    if (props.navLocalePath === undefined) {
      throw new Error('navLocalePath is undefined')
    }

    if (props.navHash === undefined) {
      throw new Error('navhash is undefined')
    }

    const hideNavi = () => {
      emit('hide-navigation', '')
    }
    return { country, shopLoginStatus, b2bShopId, hideNavi }
  },
})
